import * as React from "react";
import { DialogMessageDefaultConfig } from "./DialogMessageConstants";
import { Header, Body } from "./components";
export class DialogMessage extends React.Component {
    constructor(props) {
        super(props);
        this.state = { config: Object.assign(Object.assign({}, DialogMessageDefaultConfig), props.config) };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        return {
            config: Object.assign(Object.assign({}, prevState.config), nextProps.config)
        };
    }
    getDataUat() {
        return this.state.config.dataUat ? {
            message: `${this.state.config.dataUat}-dialog-message`,
            header: `${this.state.config.dataUat}-header`
        } : {};
    }
    render() {
        return (React.createElement("div", { className: `rj-dialog-message ${this.state.config.type} ${this.state.config.className}`, "data-uat": this.getDataUat().message },
            this.state.config.header.length > 0 && React.createElement(Header, { html: this.state.config.header, dataUat: this.getDataUat().header }),
            this.state.config.body.length > 0 && React.createElement(Body, { html: this.state.config.body, actions: this.state.config.actions }),
            this.props.children));
    }
}
//# sourceMappingURL=DialogMessage.js.map